import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import './index.css';
import { Provider } from 'jotai';
import { store } from './atomstore/store';
import { useHydrateAtoms } from 'jotai/utils';
import { queryClientAtom } from 'jotai-tanstack-query';
import ChildSelectModal from './components/common/ChildSelectModal';
import { setUserState } from './atomstore/serviceAtoms';
import App from './App';
import NotificationService from './components/common/NotificationService';

const queryClient = new QueryClient();
const HydrateAtoms = ({ children }) => {
    useHydrateAtoms([[queryClientAtom, queryClient]])
    return children
}
const root = ReactDOM.createRoot(document.getElementById('root'));

const localUser = localStorage.getItem("userstate");
if (localUser) setUserState(JSON.parse(localUser));
root.render(
    <Provider store={store} >
        <QueryClientProvider client={queryClient}>
            <HydrateAtoms>
                <ChildSelectModal />
                <NotificationService />
                <App />
            </HydrateAtoms>
        </QueryClientProvider>
    </Provider>
);